const woo = {
  init: function () {
    //woo.quick_cart.init();
    woo.events();
    woo.header.init();
    woo.update_cart();
  },

  events: function () {
    // Quantity event.
    $("body").on("click", ".number-input__btn", function () {
      let input = $(this).siblings("input");

      if (!input.is(":disabled")) {
        let currentVal = parseInt(input.val());

        if ($(this).data("type") === "minus" && currentVal > 1) {
          input.val(currentVal - 1);
          input.change();
        } else if ($(this).data("type") === "plus") {
          input.val(currentVal + 1);
          input.change();
        }
      }
    });

    $(".video__overlay").on("click", function () {
      var videoWrapper = $(this).closest(".video");
      var videoElement = videoWrapper.find("video")[0];

      if (videoWrapper.hasClass("playing")) {
        videoWrapper.removeClass("playing");
        videoElement.pause();
      } else {
        videoWrapper.addClass("playing");
        videoElement.play();
      }
    });
  },

  update_cart: function () {
    var timeout;

    $(".woocommerce").on("change", "input.qty", function () {
      // Cart page qty updates are handled by woo-cart.js (AJAX).
      if ($(this).closest(".woocommerce-cart-form").length) {
        return;
      }

      if (timeout !== undefined) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(function () {
        $("[name='update_cart']").trigger("click");
      }, 500);
    });
  },

  header: {
    init: function () {
      woo.header.events();
    },

    /**
     * Cart counts helper
     **/
    cart_count: function (count) {
      var btn = $(".cart-btn");

      switch (true) {
        case parseInt(count) > 0 && btn.find(".tooltip").length:
          btn.find(".tooltip").html(count);
          btn.find(".tooltip").addClass("visible");
          break;

        case parseInt(count) > 0:
          btn.append('<span class="tooltip">' + count + "</span>");
          btn.find(".tooltip").addClass("visible");
          break;

        case btn.find(".tooltip").length:
          btn.find(".tooltip").removeClass("visible");
          break;
      }
    },

    /**
     * Request cart count from server on pageload
     **/
    get_cart_count: function () {
      var btn = $(".cart-btn");
      $.ajax({
        url: ajaxurl,
        type: "POST",
        dataType: "JSON",
        data: {
          action: "get_cart_count",
        },
        success: function (response) {
          woo.header.cart_count(response);
        },
      });
    },

    events: function () {
      $("body").on("click", ".ajax_add_to_cart", function () {
        let button = $(this);
        var timer = setInterval(function () {
          if (button.hasClass("added")) {
            woo.header.get_cart_count();
            clearInterval(timer);
          }
        }, 200);
      });
    },
  },

  quick_cart: {
    element: $(".quick-cart"),

    init: function () {
      woo.quick_cart.toggle();
    },

    /**
     * Open QuickCart
     **/
    open: function () {
      woo.quick_cart.element.addClass("quick-cart--open");
      $("html").addClass("no-scroll");
    },

    /**
     * Close QuickCart
     **/
    close: function () {
      woo.quick_cart.element.removeClass("quick-cart--open");
      $("html").removeClass("no-scroll");
    },

    /**
     * Loaded QuickCart
     **/
    loaded: function () {
      woo.quick_cart.element.addClass("quick-cart--loaded");
    },

    /**
     * QuickCart functionality
     **/
    toggle: function () {
      $(".cart-btn").on("click", function (e) {
        e.preventDefault();

        switch (true) {
          case woo.quick_cart.element.hasClass("quick-cart--open"):
            woo.quick_cart.close();
            break;

          case woo.quick_cart.element.hasClass("quick-cart--loaded"):
            woo.quick_cart.open();
            break;

          default:
            woo.quick_cart.render();
            break;
        }
      });

      woo.quick_cart.element.on("click", ".quick-cart__close", function () {
        woo.quick_cart.close();
      });

      $(document).keyup(function (e) {
        if (woo.quick_cart.element.hasClass("quick-cart--loaded")) {
          if (e.keyCode === 27) {
            woo.quick_cart.close();
          }
        }
      });

      $(document).mouseup(function (e) {
        if (woo.quick_cart.element.hasClass("quick-cart--loaded")) {
          var container = woo.quick_cart.element.find(".quick-cart__inner");

          // if the target of the click isn't the container nor a descendant of the container
          if (!container.is(e.target) && container.has(e.target).length === 0) {
            woo.quick_cart.close();
          }
        }
      });
    },

    /**
     * Render quickcart
     **/
    render: function () {
      $.ajax({
        url: ajaxurl,
        type: "POST",
        dataType: "JSON",
        data: {
          action: "render_quick_cart",
        },
        beforeSend: function (xhr) {
          woo.quick_cart.open();
          woo.quick_cart.element.html(
            '<div class="quick-cart__loader"><i class="fa fa-cog fa-spin fa-2x fa-fw margin-bottom"></i></div>'
          );
        },
        success: function (response) {
          if (response) {
            woo.quick_cart.loaded();
            woo.quick_cart.element.html(response);
          } else {
            woo.quick_cart.close();
          }
        },
      });
    },
  },
};

export default woo;
